import { render, staticRenderFns } from "./cubeSpin.vue?vue&type=template&id=2641ad5e&scoped=true"
import script from "./cubeSpin.vue?vue&type=script&lang=js"
export * from "./cubeSpin.vue?vue&type=script&lang=js"
import style0 from "./cubeSpin.vue?vue&type=style&index=0&id=2641ad5e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29.7__cac_q4nveoxp7n4czahn54be2wnk2a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641ad5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\new-site\\wetech-website-admin\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2641ad5e')) {
      api.createRecord('2641ad5e', component.options)
    } else {
      api.reload('2641ad5e', component.options)
    }
    module.hot.accept("./cubeSpin.vue?vue&type=template&id=2641ad5e&scoped=true", function () {
      api.rerender('2641ad5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading/spin/cubeSpin.vue"
export default component.exports